import { getDictPhrase } from "../../../common";
export const getBetTitlePulseBetProps = (bet, state) => {
    return {
        name: getDictPhrase(state.dict, "PulseBet").format(bet.selections[0].selectionDisplayName)
    };
};
//# sourceMappingURL=getBetTitlePulseBetProps.js.map